import React from "react";
import * as S from "./styled";

interface IProps {
  title: string;
}

const ContentsTitle = ({ title }: IProps) => {
  return (
    <S.HomeContentsTitleWrapper>
      <h4
        data-aos="fade"
        data-aos-duration={800}
        data-aos-offset={100}
        data-aos-easing="linear"
      >
        {title}
      </h4>
    </S.HomeContentsTitleWrapper>
  );
};

export default ContentsTitle;
